import type { SVGProps } from 'react';

// Phosphor has no calf, so this is drawn to match its regular-weight Cow:
// 256 viewBox, 16px rounded strokes, currentColor. The muzzle opens at the
// bottom for a pacifier.
export const CalfIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    fill="none"
    stroke="currentColor"
    strokeWidth={16}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M72,144V80a40,40,0,0,1,40-40h32a40,40,0,0,1,40,40v64" />
    <path d="M116,40c0-16,10-24,24-24" />
    <path d="M72,80C52,72,28,80,20,108c20,10,40,6,52-4" />
    <path d="M184,80c20-8,44,0,52,28-20,10-40,6-52-4" />
    <path d="M100,216H96a40,40,0,0,1,0-80h64a40,40,0,0,1,0,80h-4" />
    <circle cx="104" cy="100" r="6" fill="currentColor" />
    <circle cx="152" cy="100" r="6" fill="currentColor" />
    <line x1="96" y1="176" x2="104" y2="176" />
    <line x1="152" y1="176" x2="160" y2="176" />
    <rect x="100" y="206" width="56" height="20" rx="10" />
    <circle cx="128" cy="238" r="8" />
  </svg>
);
